(() => {
  if (customElements.get('vanan-menu')) return;
  customElements.define('vanan-menu', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      // Wait for the header's right-hand controls to be parsed as well.
      this.frame = requestAnimationFrame(() => this.setup(signal));
    }
    setup(signal) {
      if (signal.aborted) return;
      const header = this.closest('.vanan-header');
      const top = this.querySelector('.vn__top');
      const inner = header?.querySelector('.header__inner');
      const right = header?.querySelector('.vn-right');
      const logo = header?.querySelector('.header__logo');
      if (!top || !inner || !right || !logo) return;
      const normalise = s => s.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      let more = [...top.children].find(li => normalise(li.querySelector('summary')?.textContent || '') === 'vice');
      const generated = !more;
      if (!more) {
        more = document.createElement('li');
        more.className = 'vn__item';
        more.innerHTML = '<details class="vn__details"><summary class="vn__label">VÍCE<span class="vn__chevron" aria-hidden="true"></span></summary><div class="vn__dropdown"><ul class="vn__links"></ul></div></details>';
        top.append(more);
      }
      more.classList.add('vn-overflow');
      const moreDetails = more.querySelector('details');
      const panel = moreDetails.querySelector('.vn__dropdown');
      if (!panel) return;
      const overflow = document.createElement('ul');
      overflow.className = 'vn-overflow-list';
      panel.prepend(overflow);
      const originalMoreContent = panel.querySelectorAll(':scope > :not(.vn-overflow-list)');
      const moreHasContent = [...originalMoreContent].some(n => n.querySelector('a'));
      const entries = [...top.children].filter(li => li !== more).map(node => ({node, side:'left'}));
      // Keep account/search/cart controls in place; only textual utilities may move.
      right.querySelectorAll('.header__utils-items > li').forEach(node => {
        if (node.querySelector('.nav-text-link')) entries.push({node, side:'right'});
      });
      entries.forEach(entry => {
        entry.marker = document.createComment('VANAN original menu position');
        entry.node.before(entry.marker);
      });
      const restore = () => entries.forEach(({node, marker}) => marker.after(node));
      const close = except => this.querySelectorAll('details').forEach(d => {
        if (d !== except && !d.contains(except) && !except?.contains(d)) d.open = false;
      });
      const media = matchMedia('(min-width:990px)');
      let running = false;
      const layout = () => {
        if (signal.aborted || running || !this.isConnected) return;
        running = true;
        const focused = document.activeElement;
        restore();
        more.hidden = generated;
        if (media.matches && inner.clientWidth) {
          more.hidden = false; // Reserve space for VÍCE while fitting candidates.
          const gap = 32;
          const lr = logo.getBoundingClientRect();
          const fitsRight = () => [...right.querySelectorAll('.header__utils-items, .vn__contact')].filter(n => n.getClientRects().length).every(n => n.getBoundingClientRect().left >= lr.right + gap - 0.5);
          // Remove the last text link first (normally Kontakt), country selector last.
          const rightEntries = entries.filter(e => e.side === 'right');
          rightEntries.sort((a,b) => Number(!!a.node.querySelector('desktop-drawer')) - Number(!!b.node.querySelector('desktop-drawer')));
          for (const entry of rightEntries) {
            if (fitsRight()) break;
            overflow.append(entry.node);
          }
          const leftEntries = entries.filter(e => e.side === 'left');
          const fitsLeft = () => top.getBoundingClientRect().right <= lr.left - gap + 0.5;
          // When all links fit without an otherwise empty VÍCE, omit it.
          if (!moreHasContent && !overflow.children.length) {
            more.hidden = true;
            if (!fitsLeft()) more.hidden = false;
          }
          for (const entry of [...leftEntries].reverse()) {
            if (fitsLeft()) break;
            overflow.prepend(entry.node);
          }
          more.hidden = !moreHasContent && !overflow.children.length;
        } else {
          moreDetails.open = false;
        }
        if (focused && focused !== document.body && focused.isConnected) {
          if (overflow.contains(focused) && !moreDetails.open) more.querySelector('summary').focus({preventScroll:true});
          else if (document.activeElement !== focused) focused.focus({preventScroll:true});
        }
        running = false;
      };
      const schedule = () => {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(layout);
      };
      this.addEventListener('pointerover', e => {
        if (e.pointerType !== 'mouse') return;
        const d = e.target.closest('details');
        if (!d || !this.contains(d) || d.contains(e.relatedTarget)) return;
        clearTimeout(this.timer); close(d); d.open = true;
      }, {signal});
      this.addEventListener('pointerleave', e => {
        if (e.pointerType === 'mouse') this.timer = setTimeout(() => {
          if (!this.contains(document.activeElement)) close();
        }, 220);
      }, {signal});
      this.addEventListener('pointerenter', () => clearTimeout(this.timer), {signal});
      this.addEventListener('toggle', e => { if (e.target.open) close(e.target); }, {signal, capture:true});
      this.addEventListener('keydown', e => {
        if (e.key !== 'Escape') return;
        const d = e.target.closest('details[open]') || this.querySelector('details[open]');
        if (d) { e.preventDefault(); d.open = false; d.querySelector('summary').focus(); }
      }, {signal});
      this.addEventListener('focusout', () => queueMicrotask(() => {
        if (!this.contains(document.activeElement)) close();
      }), {signal});
      document.addEventListener('pointerdown', e => { if (!this.contains(e.target)) close(); }, {signal});
      window.addEventListener('resize', schedule, {signal});
      this.observer = new ResizeObserver(schedule);
      [inner, logo, right].forEach(n => this.observer.observe(n));
      document.fonts?.ready.then(schedule);
      document.fonts?.addEventListener('loadingdone', schedule, {signal});
      this.cleanup = () => {
        restore(); entries.forEach(e => e.marker.remove()); overflow.remove();
        if (generated) more.remove(); else { more.hidden = false; more.classList.remove('vn-overflow'); }
      };
      layout();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect();
      cancelAnimationFrame(this.frame); cancelAnimationFrame(this.layoutFrame);
      clearTimeout(this.timer); this.cleanup?.(); this.cleanup = null;
    }
  });
})();